/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes,extraRequire}
 * tslint:disable
 */
var styles = [".mat-dialog-title[_ngcontent-%COMP%]{border-bottom:none!important;justify-content:left!important;line-height:30px}.mat-dialog-title[_ngcontent-%COMP%]   .mat-icon[_ngcontent-%COMP%]{font-size:30px;margin-right:12px}.mat-dialog-content[_ngcontent-%COMP%]{padding-bottom:18px!important}.mat-dialog-content[_ngcontent-%COMP%]   p[_ngcontent-%COMP%]{padding-left:16px}.mat-dialog-actions[_ngcontent-%COMP%]{margin:0!important;padding-top:18px!important;padding-bottom:0!important}"];
export { styles as styles };

